module.exports = __webpack_public_path__ + "img/inspect_total_bg.960068d3.png";